import React from 'react'
import { Map } from 'immutable'

const ValidationError = ({ errorMessage }) => {
  if ((errorMessage || Map()).get('start')) {
    return (
      <div className="has-error">
        <span className="help-block error-message">
          <i className="icon icon-error" />
          <span className="text">{errorMessage.get('start')}</span>
        </span>
      </div>
    )
  }
  return null
}

export default ValidationError
